<a class="reward-token-card-info-link" (click)="trackTokenInfoLinkClick()">
    <span [innerHTML]="overrideLinkTitleHtml || tokenInfoLinkText"></span>
    @if (withArrow) {
        <i class="theme-right"></i>
    }
</a>
